import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { FormService } from '../../services/form.service';
import { FormComponent } from '../form/form.component';
import { MdDialog, MdDialogRef } from '@angular/material';
import { PaginatedForms, Form, Item } from '../../models/form';
import { ConfirmDeleteDialogComponent } from '../confirm-delete-dialog/confirm-delete-dialog.component';
import { MessageBoxDialog } from '../message-box/message-box.component';

@Component({
  selector: 'app-view-form',
  templateUrl: './view-form.component.html',
  styleUrls: ['./view-form.component.css']
})
export class ViewFormComponent implements OnInit {

  forms: Form[];
  loading: boolean;

  page: number;
  total: number;
  max: number;

  selectedOption: string;
  errorMessage:string;

  constructor(private formService: FormService, public dialog: MdDialog) {
    this.loading = true;
    this.page = 1;
    this.total = 0;
    this.max = 10;
  }

  ngOnInit() {
    this.searchForms();
  }

  openDialog (name, id) {
      let dialogRef = this.dialog.open(FormComponent);
      dialogRef.afterClosed().subscribe(result => {
        this.selectedOption = result;
        this.searchForms(this.page);
      });
      dialogRef.componentInstance.nameComponent=name;
      dialogRef.componentInstance.FormID=id;
      dialogRef.componentInstance.Forms=this.forms;
  }

  searchForms (page?: number, query?: string, active?: boolean, deleted?: boolean) {
    this.loading = true;
    const status = [];

    this.page = page;
    if (page == null) {
      page = 1;
    }

    if (active) {
        status.push('1');
    }

    if (deleted) {
        status.push('-6');
    }

    this.formService.getForms(page, this.max, query, status)
    .subscribe(
    data => {
      this.forms = data.forms;
      this.total = data.pagination.total;
      this.loading = false;
    },
    error => {
      if (error.status == 404) {
        this.forms = undefined;
        this.loading = false;
      } else {
        console.log(error);
        this.forms = undefined;
        this.loading = false;
      }
    });
  }

  onPageChange(page) {
    this.searchForms (page);
  }

  openDialogDelete(id) {
      const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent);
      dialogRef.componentInstance.deleteForm = true;
      dialogRef.componentInstance.FormID = id;
      dialogRef.componentInstance.FormStatus = -6;
      dialogRef.afterClosed().subscribe(result => {
        this.searchForms (this.page);
      });
  }

  getTypeName(id) {
    if (id === 1) {
      return 'Selección Simple (S/N)';
    } else if (id === 2) {
      return 'Texto (Máx 140 caractéres)';
    } else if (id === 3) {
      return 'Selección Simple (A,B,C,D)';
    } else if (id === 4) {
      return 'Selección Multiple (A,B,C,D)';
    } else {
      return 'Desconocido';
    }
  }

  showInformation() {
    this.dialog.open(MessageBoxDialog, {data: {message: 'Crea formularios para asociarlos a tus ofertas y que tus postulados respondan a través de nuestros robots inteligentes.', information: true, showIcon: true}});
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/view-form/view-form.component.ts